import {
  useCreateProjectForm
} from "./chunk-PVCBGE2K.js";

// src/organization/create.tsx
import { AnimatePanes, Dialog, Spacer, Text, Title, showModal } from "@lb-lib/ui";
import { useFormComponent } from "@lb-lib/ui-data";
import { useCreateOrganization, workspaceBootState } from "@loopbound-ares/state";
import { useRef, useState } from "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var InnerProject = (opts) => {
  let ProjectForm = useCreateProjectForm({
    redirectOnCreate: true,
    workspaceProduct: opts.workspaceProduct
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Title, { as: "h1", size: "4", weight: "strong", children: "What project are you working on?" }),
    /* @__PURE__ */ jsx(Spacer, { height: "10px" }),
    /* @__PURE__ */ jsx(Text, { size: "2", weight: "medium", color: "gray600", children: "Finally, let's set up your first projects. Projects are where you organize your work. You can always add more projects later." }),
    /* @__PURE__ */ jsx(Spacer, { height: "30px" }),
    /* @__PURE__ */ jsx(ProjectForm, { hasCancelButton: false, onSuccess: close })
  ] });
};
var Inner = () => {
  let [currentStep, setCurrentStep] = useState("info");
  let [org, setOrg] = useState();
  let OrgForm = useFormComponent(() => ({
    initialData: {
      name: ""
    },
    fields: [{
      key: "name",
      kind: "text",
      type: "textfield",
      label: "Organization Name",
      placeholder: "Enter your organization name",
      validation: (yup) => yup.string().required("Organization name is required")
    }],
    state: () => {
      let createOrg = useCreateOrganization();
      return {
        isLoading: createOrg.isLoading,
        isSuccess: createOrg.isSuccess,
        initialData: {
          name: ""
        },
        mutate: async (data) => {
          let orgRes = await createOrg.mutate(data);
          if (orgRes) {
            let input = {
              workspaceId: orgRes.workspaces[0].id
            };
            let workspaceRes = await workspaceBootState.fetchAndReturn(input);
            setOrg({
              organization: orgRes.organization,
              workspace: orgRes.workspaces[0],
              workspaceProduct: workspaceRes.productWorkspace
            });
            setCurrentStep("project");
          }
        }
      };
    },
    submitButton: {
      children: "Create Organization"
    }
  }));
  let orgRef = useRef(org);
  orgRef.current = org;
  if (currentStep == "info") {
    return /* @__PURE__ */ jsx(AnimatePanes, { orderedIdentifier: 0, children: /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Title, { as: "h1", size: "4", weight: "strong", children: "Create Organization" }),
      /* @__PURE__ */ jsx(Spacer, { height: "10px" }),
      /* @__PURE__ */ jsx(Text, { size: "2", weight: "medium", color: "gray600", children: "Please tell us a bit about your organization to get started. You can always change this information later." }),
      /* @__PURE__ */ jsx(Spacer, { height: "30px" }),
      /* @__PURE__ */ jsx(OrgForm, {})
    ] }) }, "panes");
  }
  if (currentStep == "project") {
    if (!orgRef.current?.workspaceProduct)
      return null;
    return /* @__PURE__ */ jsx(AnimatePanes, { orderedIdentifier: 1, children: /* @__PURE__ */ jsx(InnerProject, { workspaceProduct: orgRef.current.workspaceProduct }) }, "panes");
  }
  throw new Error("Invalid step");
};
var createOrganization = () => {
  showModal(({
    dialogProps
  }) => /* @__PURE__ */ jsx(Dialog.Wrapper, { variant: "padded", ...dialogProps, autoCloseOnSubmit: false, children: /* @__PURE__ */ jsx(Inner, {}) }));
};
var CreateOrganization = () => /* @__PURE__ */ jsx(Inner, {});

export {
  createOrganization,
  CreateOrganization
};
//# sourceMappingURL=chunk-MJWTRZ63.js.map